import { render, staticRenderFns } from "./collectCoupons.vue?vue&type=template&id=f6c4364c&scoped=true&"
import script from "./collectCoupons.vue?vue&type=script&lang=js&"
export * from "./collectCoupons.vue?vue&type=script&lang=js&"
import style0 from "./collectCoupons.vue?vue&type=style&index=0&id=f6c4364c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c4364c",
  null
  
)

export default component.exports